import { useMemo, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { type TabItemId } from '@garnish/layout';

import { CUSTOMIZATIONS_TABS } from '../../../../../../constants';

// ─────────────────────────────────────────────────────────────────────────────

export const useCustomizationTabs = () => {
  const { formatMessage } = useIntl();

  // ─── State ───────────────────────────────────────────────────────────

  const [activeTabItemId, setActiveTabItemId] = useState<TabItemId>(
    CUSTOMIZATIONS_TABS.ADD_INGREDIENTS,
  );

  // ─────────────────────────────────────────────────────────────────────

  const tabs = useMemo(
    () => [
      {
        id: CUSTOMIZATIONS_TABS.ADD_INGREDIENTS,
        label: formatMessage(messages.addIngredients),
        panelId: CUSTOMIZATIONS_TABS.ADD_INGREDIENTS,
      },
      {
        id: CUSTOMIZATIONS_TABS.REVIEW,
        label: formatMessage(messages.review),
        panelId: CUSTOMIZATIONS_TABS.REVIEW,
      },
    ],
    [formatMessage],
  );

  // ─────────────────────────────────────────────────────────────────────

  return {
    tabs,
    activeTabItemId,
    setActiveTabItemId,
  };
};

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages({
  addIngredients: {
    defaultMessage: 'Add ingredients',
    description: 'Customization | Ingredients | Add ingredients | Tab Label',
  },
  review: {
    defaultMessage: 'Review',
    description: 'Customization | Ingredients | Review | Tab Label',
  },
});
